import React, {Component} from 'react';
import 'aos/dist/aos.css';
import moment from "moment";
import {RichText} from "prismic-reactjs";
import {withStyles} from '@material-ui/core/styles';
import SocialIcons from "./SocialIcons";
import Sitemap from "./Sitemap";
import Container from "./Container";
import Section from "./Section";
import EmailSubscribeForm from "./EmailSubscribeForm";
import TrackedEmail from "./TrackedEmail";
import {openChat} from "../utilities";


class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscribed: false,
    }
  }

  subscribe = (values) => {
    return fetch("https://hooks.zapier.com/hooks/catch/2488913/wcxscv/", {
      method: 'POST',
      body: JSON.stringify({
        email: values.email,
      }),
    }).then(response => {
      window.analytics.track('Newsletter - Subscribed', {location: 'Footer'});

      window.analytics.identify({
        email: values.email,
      });

      window.localStorage.setItem('subscribed', 'true');
      window.suppressSubscribePopup = true;

      this.setState({
        subscribed: true,
      });
    });
  };

  render() {
    const {data, classes} = this.props;

    return (
      <footer className={classes.footer}>
        <Section className={classes.section}>
          <Container className={classes.container}>
            <div>
              <Sitemap className={classes.sitemap}/>
              {(this.state.subscribed) ?
                <div className={classes.thankYou}>Welcome to the Gridhaus family. We’ll be keeping you in the
                  loop!</div> :
                <EmailSubscribeForm onSubmit={this.subscribe} className={classes.subscribe}/>
              }
            </div>
            <div className={classes.info}>
              <SocialIcons
                className={classes.socialIcons}
                smItems={data.social_media_links.map(smlink => ({
                  link: smlink.link,
                  iconUrl: smlink.icon.url,
                }))}/>
              <div className={classes.address}>
                {RichText.render(data.address)}
              </div>
              <TrackedEmail onClick={openChat} onContextMenu={openChat} onCopy={openChat}
                            className={classes.email}
                            location={'Footer'}
                            email={data.email}/>
              <div className={classes.meta}>
                &copy; {moment().format('YYYY')} {data.business_reference}. All rights reserved.
              </div>
            </div>
          </Container>
        </Section>
      </footer>
    )
  }
}


export default withStyles((theme) => ({
  footer: {
    background: theme.palette.secondary.dark,
  },
  section: {
    paddingTop: theme.spacing.unit * 6,
    paddingBottom: theme.spacing.unit * 6,
  },
  sitemap: {
    marginBottom: theme.spacing.unit * 4,
  },
  subscribe: {
    marginBottom: theme.spacing.unit * 2,
  },
  info: {
    maxWidth: 400,
  },
  socialIcons: {
    marginBottom: theme.spacing.unit,
  },
  address: {
    color: theme.palette.secondary.main,
    ...theme.typography.hg18r(theme),
    marginBottom: '1em',
  },
  email: {
    display: 'inline-block',
    color: theme.palette.secondary.main,
    ...theme.typography.hg18r(theme),
    marginBottom: '1em',
  },
  meta: {
    color: theme.palette.darkGrey,
    ...theme.typography.hg14r(theme),
    marginBottom: '1em',
  },
  thankYou: {
    color: theme.palette.secondary.main,
    ...theme.typography.hg18r(theme),
    marginBottom: '1em',
  },
  [theme.breakpoints.up(1280)]: {
    container: {
      display: 'flex',
      justifyContent: 'space-between',
    }
  },
}))(Footer);


// WEBPACK FOOTER //
// ./src/parts/Footer.js